var _circle, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon40Customer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.5,
    r: 19.25,
    stroke: "#FFE600",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.5,
    r: 20,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    stroke: "#FFE600",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.347 25.64v4l-7.334 2.607a4.393 4.393 0 00-2.105 1.604m26.164.002a4.38 4.38 0 00-2.105-1.6l-7.334-2.613v-4.267M27.074 17.127c-.247.033-.44 0-.667.073-2.487.48-4.08-.427-5.453-2.82-.82 1.573-3.387 2.82-5.5 2.82a5.9 5.9 0 01-2.827-.667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.82 26.686c4.031 0 7.3-3.921 7.3-8.76 0-4.837-3.269-8.76-7.3-8.76-4.032 0-7.3 3.922-7.3 8.76 0 4.839 3.268 8.76 7.3 8.76z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon40Customer);
export default __webpack_public_path__ + "static/media/icon-40-customer.95d4aa2c92300486c0bae47006e50e7b.svg";
export { ForwardRef as ReactComponent };